import React from "react";
import styled from "styled-components";

import Layout from "@components/Layout";

import { Container } from "@styles/grid";

import BundleAddForm from "./BundleAddForm";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 3rem 5.5rem 5.5rem;
`;

const BundleAdd = () => {
  return (
    <Layout pageTitle="Add Bundle">
      <Container>
        <Content>
          <BundleAddForm />
        </Content>
      </Container>
    </Layout>
  );
};

export default BundleAdd;
